import type { SourceType } from "@/services/lineageEdgeService";

export const SOURCE_TEXT_LIMIT = 120;
export const SOURCE_SUBTEXT_LIMIT = 140;

export function truncateSourceText(text: string, maxLength: number): string {
  const normalized = text.trim();
  if (normalized.length <= maxLength) return normalized;
  return `${normalized.slice(0, maxLength - 1)}…`;
}

export function sourceFallbackTitle(type: SourceType): string {
  switch (type) {
    case "document":
      return "Untitled document";
    case "assumption":
      return "Untitled assumption";
    case "hypothesis":
      return "Untitled hypothesis";
    case "experiment":
      return "Untitled experiment";
    case "learning":
      return "Untitled learning";
    case "insight":
      return "Untitled insight";
    default:
      return "Untitled source";
  }
}
